import React, { useState, useEffect } from 'react';
import API from 'config/ApiConfig';

export default function CreateRekap() {
  const [formData, setFormData] = useState({
    tentor_id: '',
    siswa_id: '',
    harga: '',
    pendapatan: '',
    mata_pelajaran: '',
    waktu_pembelajaran: '',
    jam: '',
    durasi:'',
    feedback: '',
    ulasan: '',
  });
  const [tentors, setTentors] = useState([]);
  const [siswa, setSiswa] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  // const API_BASE_URL = 'http://localhost:5000/api/admin';
  const API_BASE_URL = API.API_ADMIN
  const JWT_TOKEN = localStorage.getItem('authToken');

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  useEffect(() => {
    // Fetch list of tentors
    const fetchTentors = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/tentor`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setTentors(data);
      } catch (error) {
        console.error('Error fetching tentors:', error);
        setFetchError('Failed to fetch tentors.');
      }
    };

    // Fetch list of siswa
    const fetchSiswa = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/siswa`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setSiswa(data);
      } catch (error) {
        console.error('Error fetching siswa:', error);
        setFetchError('Failed to fetch siswa.');
      }
    };

    fetchTentors();
    fetchSiswa();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/rekap`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Redirect to the list of rekap
      alert('Berhasil Membuat Presensi');
      window.location.href = '/admin/presensi';
    } catch (error) {
      console.error('Error creating rekap:', error);
      setFetchError('Failed to create rekap.');
    }
  };
//   const handleSubmitButton = () => {
//     alert("Berhasil Membuat Presensi");
//     window.location.href="/admin/rekap"
//   }

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Create Presensi</h3>
      {fetchError && <p className="text-red-500 text-xs">{fetchError}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Tentor Dropdown */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Pilih Tentor:</label>
          <select
            name="tentor_id"
            value={formData.tentor_id}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          >
            <option value="">Pilih Tentor</option>
            {tentors.map((tentor) => (
              <option key={tentor._id} value={tentor._id}>
                {tentor.nama}
              </option>
            ))}
          </select>
        </div>
        {/* Siswa Dropdown */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Pilih Siswa:</label>
          <select
            name="siswa_id"
            value={formData.siswa_id}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          >
            <option value="">Pilih Siswa</option>
            {siswa.map((siswaItem) => (
              <option key={siswaItem._id} value={siswaItem._id}>
                {siswaItem.nama}
              </option>
            ))}
          </select>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Harga:</label>
          <input
            type="number"
            name="harga"
            value={formData.harga}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            placeholder="contoh 25000"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-red-500">Pendapatan Bersih:</label>
          <input
            type="number"
            name="pendapatan"
            value={formData.pendapatan}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            placeholder="Biaya les - biaya tentor, ex. 15000"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Mata Pelajaran:</label>
          <input
            type="text"
            name="mata_pelajaran"
            value={formData.mata_pelajaran}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Waktu Pembelajaran:</label>
          <input
            type="date" 
            // type="datetime-local"
            name="waktu_pembelajaran"
            value={formData.waktu_pembelajaran}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            required
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Jam:</label>
          <input
            type="text"
            name="jam"
            value={formData.jam}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Durasi:</label>
          <input
            type="text"
            name="durasi"
            value={formData.durasi}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
            placeholder='Masukan menit, misal 90 menit'
          />
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Catatan Belajar Siswa:</label>
          <textarea
            name="feedback"
            value={formData.feedback}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div>
        {/* <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Ulasan:</label>
          <textarea
            name="ulasan"
            value={formData.ulasan}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div> */}
        <div>
          <button
            type="submit"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            // onclick = {handleSubmitButton}
          >
            Create Presensi
          </button>
          <a href="/admin/presensi">
            <button
              type="button"
              className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            >
              Cancel
            </button>
          </a>
        </div>
      </form>
    </div>
  );
}
